import {
  ElementRef,
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { FusionarPacienteDialogComponent } from "../fusionar-paciente-dialog/fusionar-paciente-dialog.component";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { FotoDialogComponent } from "app/shared/foto-dialog/foto-dialog.component";
import { Paciente } from "app/models/paciente.interface";
import { PacienteService } from "app/services/paciente.service";
import { Router } from "@angular/router";
import { ObraSocial } from "app/models/obraSocial.interface";
import { TipoDocumento } from "app/models/tipoDocumento.interface";
import { TelefonoPais } from "app/models/telefonoPais.interface";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationComponent } from "app/shared/notification/notification.component";
import { GlobalVariable } from "app/global/global";
import { ThemePalette } from "@angular/material/core";
import { SpinnerService } from "app/services/spinner.service";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";

@Component({
  selector: "app-crear-form-paciente",
  templateUrl: "./crear-form-paciente.component.html",
  styleUrls: ["./crear-form-paciente.component.scss"],
})
export class CrearFormPacienteComponent implements OnInit {
  //
  funcionCorrecta: any;
  editarValor: boolean;
  url: string = GlobalVariable.BASE_API_URL + "storage/images/paciente/";
  @Output() listar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() set editar(value: boolean) {
    this.editarValor = value;
    this.panelOpenState = value ? true : false;
  }
  @ViewChild("UploadFileInput") uploadFileInput: ElementRef;
  @ViewChild("divImagen") divImagen: ElementRef;
  public telPais: FormControl = new FormControl();
  public celPais: FormControl = new FormControl();
  panelOpenState = false;
  file: File = null;
  nameImage: string = "";
  imagen = "";
  myfilename = "Seleccionar archivo";
  button: string;
  paciente: Paciente;
  telefonoPais: TelefonoPais[];
  filtroTelefonoPais: TelefonoPais[] = [];
  filtroCelularPais: TelefonoPais[] = [];
  obrasSociales: ObraSocial[];
  filtroObrasSociales: ObraSocial[] = [];
  public obraSocialBuscador: FormControl = new FormControl();
  tiposDocumentos: TipoDocumento[];
  color: ThemePalette = "accent";
  checked = false;
  disabled = false;
  responseCreate: any;
  errorDocumento: any;
  errorNumeroDocumento: any;
  errorTipoDocumento: any;
  errorNumeroAfiliado: any;
  errorEmail: any;
  errorDeclaracionJurada: any;
  errorGender: any;
  recetasHabilitadas: boolean = false;
  public telPaisBuscador: FormControl = new FormControl();
  public celPaisBuscador: FormControl = new FormControl();
  pacienteForm = new FormGroup({
    id: new FormControl(""),
    name: new FormControl("", Validators.required),
    surname: new FormControl("", Validators.required),
    gender: new FormControl("", Validators.required),
    tipoDocumento: new FormControl("", Validators.required),
    numeroDocumento: new FormControl("", Validators.required),
    obraSocial: new FormControl(0),
    numeroAfiliado: new FormControl(""),
    planObraSocial: new FormControl(""),
    direccion: new FormControl("", Validators.required),
    fechaNacimiento: new FormControl(null, Validators.required),
    edad: new FormControl(""),
    email: new FormControl("", [Validators.required, Validators.email]),
    telPaisBuscador: new FormControl(""),
    telPais: new FormControl("", Validators.required),
    telCaract: new FormControl("", Validators.required),
    telNumero: new FormControl("", Validators.required),
    celPaisBuscador: new FormControl(""),
    celPais: new FormControl("", Validators.required),
    celCaract: new FormControl("", Validators.required),
    celNumero: new FormControl("", Validators.required),
    codigoInterno: new FormControl(""),
    memberContactNo: new FormControl(""),
    modificar: new FormControl(true),
    declaracion_jurada_aceptada: new FormControl(
      false,
      Validators.requiredTrue,
    ),
  });
  @Input() set response(value: any) {
    if (value) {
      this.formMostrarValores(value);
      if (value.paciente) {
        this.iniciarFormularioEditado(value.paciente);
      }
    }
  }
  currentDate = new Date();

  //
  constructor(
    public fotoDialog: MatDialog,
    private pacienteService: PacienteService,
    private router: Router,
    private snackBar: MatSnackBar,
    private spinnerService: SpinnerService,
  ) {}

  //
  ngOnInit(): void {
    if (!this.editarValor) {
      this.pacienteForm.get("edad").disable();
    }
  }

  //
  ocultarMostrar() {
    this.panelOpenState = this.panelOpenState == true ? false : true;
  }

  //
  clearDeclaracionJurada() {
    this.errorDeclaracionJurada = false;
  }

  //
  clearNumeroDocumento() {
    this.errorNumeroDocumento = false;
    this.errorDocumento = false;
  }

  //
  clearTipoDocumento() {
    this.errorTipoDocumento = false;
    this.errorDocumento = false;
  }

  //
  clearNumeroAfiliado() {
    this.errorNumeroAfiliado = false;
  }

  //
  clearEmail() {
    this.errorEmail = false;
  }

  //
  formMostrarValores(value) {
    this.telefonoPais = value.listaTelefonoPais;
    this.filtroTelefonoPais = value.listaTelefonoPais;
    this.filtroCelularPais = value.listaTelefonoPais;
    this.tiposDocumentos = value.listatipoDocumento;
    this.obrasSociales = (value.obraSocial || []).sort((a, b) => a.nombre.localeCompare(b.nombre));
    this.filtroObrasSociales = [...this.obrasSociales];
    this.recetasHabilitadas = value.plan?.cantidadRecetas > 0;
    if (!this.recetasHabilitadas) {
      this.pacienteForm.get('obraSocial').clearValidators();
      this.pacienteForm.get('obraSocial').updateValueAndValidity();
    }
  }

  //
  iniciarFormularioEditado(data: any) {
    this.paciente = data;
    if (!this.imagen) {
      const defaultIcons = ['ico_paciente.png', 'ico_pacienteM.png'];
      const imagen = this.paciente.imagen || "ico_paciente.png";
      if (defaultIcons.includes(imagen)) {
        this.imagen = `assets/img/${imagen}`;
      } else {
        this.imagen = `${this.url}${imagen}`;
      }
      this.divImagen.nativeElement.style.display = "block";
      this.nameImage = imagen;
    }

    this.pacienteForm.patchValue({
      id: this.paciente.id,
      name: this.paciente.name || "",
      surname: this.paciente.surname || "",
      gender: this.paciente.gender || "",
      tipoDocumento: this.paciente.tipoDocumento
        ? this.paciente.tipoDocumento
        : "",
      numeroDocumento: this.paciente.numeroDocumento
        ? this.paciente.numeroDocumento
        : "",
      obraSocial: this.paciente.obraSocial ? Number(this.paciente.obraSocial) : 0,
      numeroAfiliado:
        !this.paciente.numeroAfiliado || this.paciente.numeroAfiliado == "null"
          ? ""
          : this.paciente.numeroAfiliado,
      planObraSocial: this.paciente.planObraSocial || "",
      direccion: this.paciente.direccion ? this.paciente.direccion : "",
      fechaNacimiento: this.paciente.fechaNacimiento
        ? new Date(this.paciente.fechaNacimiento)
        : null,
      edad: this.paciente.edad ? this.paciente.edad : "",
      email:
        !this.paciente.email || this.paciente.email == "null"
          ? ""
          : this.paciente.email,
      telPaisBuscador: "",
      telPais:
        !this.paciente.telPais || this.paciente.telPais == "null"
          ? ""
          : this.paciente.telPais,
      telCaract:
        !this.paciente.telCaract || this.paciente.telCaract == "null"
          ? ""
          : this.paciente.telCaract,
      telNumero:
        !this.paciente.telNumero || this.paciente.telNumero == "null"
          ? ""
          : this.paciente.telNumero,
      celPaisBuscador: "",
      celPais:
        !this.paciente.celPais || this.paciente.celPais == "null"
          ? ""
          : this.paciente.celPais,
      celCaract:
        !this.paciente.celCaract || this.paciente.celCaract == "null"
          ? ""
          : this.paciente.celCaract,
      celNumero:
        !this.paciente.celNumero || this.paciente.celNumero == "null"
          ? ""
          : this.paciente.celNumero,
      codigoInterno: this.paciente.codigoInterno
        ? this.paciente.codigoInterno
        : "",
      memberContactNo: this.paciente.imagen
        ? this.paciente.imagen
        : "Seleccionar archivo",
      modificar: this.paciente.modificar.toString() == "0" ? false : true,
      declaracion_jurada_aceptada: true,
    });

    this.pacienteForm.get("edad").disable();
  }

  //
  filtrarTelPais(event: any) {
    let textBuscador: string = this.telPaisBuscador.value;
    this.filtroTelefonoPais = this.telefonoPais.filter(function (element) {
      if (element.nombre.toUpperCase().includes(textBuscador.toUpperCase())) {
        return element;
      }
    });
  }

  //
  filtrarCelPais(event: any) {
    let textBuscador: string = this.celPaisBuscador.value;
    this.filtroCelularPais = this.telefonoPais.filter(function (element) {
      if (element.nombre.toUpperCase().includes(textBuscador.toUpperCase())) {
        return element;
      }
    });
  }

  //
  cambiarModificar(event: any) {
    this.pacienteForm.patchValue({
      modificar: event.checked,
    });
  }

  //
  guardarPaciente(form: any) {
    if (this.pacienteForm.invalid) {
      this.pacienteForm.markAllAsTouched();
      const faltantes = this.obtenerCamposObligatoriosFaltantes();
      this.openSnackBar(
        faltantes.length
          ? "Completá los campos obligatorios: " + faltantes.join(", ")
          : "Revisá los datos marcados en el formulario",
        "error",
      );
      return;
    }
    this.funcionCorrecta = this.editarValor
      ? this.editarPaciente(form)
      : this.crearPaciente(form);
  }

  private obtenerCamposObligatoriosFaltantes(): string[] {
    const obligatorios: { [control: string]: string } = {
      name: "Nombre",
      surname: "Apellido",
      gender: "Género",
      tipoDocumento: "Tipo de documento",
      numeroDocumento: "Número de documento",
      direccion: "Dirección",
      fechaNacimiento: "Fecha de nacimiento",
      email: "Email",
      telPais: "Teléfono",
      telCaract: "Teléfono",
      telNumero: "Teléfono",
      celPais: "Celular",
      celCaract: "Celular",
      celNumero: "Celular",
      numeroAfiliado: "Número de afiliado",
      declaracion_jurada_aceptada: "Declaración jurada",
    };
    const faltantes = Object.keys(obligatorios)
      .filter((control) => this.pacienteForm.get(control)?.invalid)
      .map((control) => obligatorios[control]);
    return Array.from(new Set(faltantes));
  }

  //
  crearPaciente(paciente: Paciente) {
    if (this.pacienteForm.valid) {
      this.spinnerService.mostrarSpinner();
      this.pacienteService
        .crear(this.nameImage, paciente, this.file)
        .subscribe(
          (data) => {
            let response: any = data;
            if (response.statusError) {
              this.errorNumeroDocumento = response.errorNumeroDocumento;
              this.errorTipoDocumento = response.errorTipoDocumento;
              this.errorDocumento = response.errorDocumento;
              this.errorNumeroAfiliado = response.errorNumeroAfiliado;
              this.errorEmail = response.errorEmail;
              this.errorDeclaracionJurada = response.errorDeclaracionJurada;
              this.spinnerService.ocultarSpinner();
              this.openSnackBar(
                response.mensaje || "Guardado fallido",
                "error",
              );
            } else {
              this.listar.emit();
              this.resetearFormulario();
              this.openSnackBar("Guardado exitoso", "exito");
            }
          },
          (error) => {
            this.spinnerService.ocultarSpinner();
            this.openSnackBar("Guardado fallido", "error");
          },
        );
    } else {
      this.openSnackBar("Guardado fallido", "error");
    }
  }

  //
  editarPaciente(paciente: any) {
    if (this.pacienteForm.valid) {
      this.spinnerService.mostrarSpinner();
      this.pacienteService
        .editar(this.nameImage, paciente, this.file)
        .subscribe(
          (data) => {
            let response: any = data;
            if (response.statusError) {
              this.errorNumeroDocumento = response.errorNumeroDocumento;
              this.errorTipoDocumento = response.errorTipoDocumento;
              this.errorDocumento = response.errorDocumento;
              this.errorNumeroAfiliado = response.errorNumeroAfiliado;
              this.errorEmail = response.errorEmail;
              this.spinnerService.ocultarSpinner();
              this.openSnackBar("Editado fallido", "error");
            } else {
              this.openSnackBar("Editado exitoso", "exito");
              this.router.navigate(["/seccion-panel/paciente/"]);
            }
          },
          (error) => {
            this.spinnerService.ocultarSpinner();
            this.openSnackBar("Editado fallido", "error");
          },
        );
    } else {
      this.openSnackBar("Editado fallido", "error");
    }
  }

  //
  resetearFormulario() {
    this.file = null;
    this.pacienteForm.reset();
    this.imagen = "";
    this.pacienteForm.patchValue({
      id: "",
      name: "",
      surname: "",
      gender: "",
      tipoDocumento: "",
      numeroDocumento: "",
      obraSocial: 0,
      numeroAfiliado: "",
      planObraSocial: "",
      direccion: "",
      fechaNacimiento: "",
      email: "",
      telPaisBuscador: "",
      telPais: "",
      telCaract: "",
      telNumero: "",
      celPaisBuscador: "",
      celPais: "",
      celCaract: "",
      celNumero: "",
      codigoInterno: "",
      memberContactNo: "Seleccionar archivo",
      modificar: true,
      declaracion_jurada_aceptada: false,
    });
    this.checked = true;
    this.divImagen.nativeElement.style.display = "none";
    this.panelOpenState = false;
  }

  //
  fileChangeEvent(event: any) {
    var target = event.target || event.srcElement;
  }

  //
  openSnackBar(message: string, action: string) {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: {
        message: message[0].toUpperCase() + message.slice(1),
        action: action,
      },
      duration: 2500,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: [action],
    });
  }

  //
  abrirFusion() {
    this.fotoDialog
      .open(FusionarPacienteDialogComponent, {
        width: "520px",
        data: { pacienteId: this.paciente.id },
      })
      .afterClosed()
      .subscribe((r) => {
        if (!r) {
          return;
        }
        if (r.error) {
          this.openSnackBar(r.error, "error");
          return;
        }
        this.openSnackBar(
          "Se unieron los pacientes: " +
            r.estudios_movidos +
            " estudio(s) movidos",
          "exito",
        );
        this.router.navigate(["/seccion-panel/paciente/"]);
      });
  }

  //
  openDialogFoto() {
    const dialogRef = this.fotoDialog.open(FotoDialogComponent, {
      width: "50%",
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res.data == "" && res.img == "") {
      } else {
        if (
          res.data.id == "ico_paciente.png" ||
          res.data.id == "ico_pacienteM.png"
        ) {
          this.myfilename = res.data.id;

          this.imagen = "assets/img/" + res.data.id + "";
          this.nameImage = res.data.id;
          this.divImagen.nativeElement.style.display = "block";
        } else {
          this.myfilename = res.data.name;
          this.imagen = res.img;
          this.divImagen.nativeElement.style.display = "block";
          this.file = res.data;
          this.nameImage = "";
        }
      }
    });
  }

  filtrarObraSocial(event: any) {
    const texto = this.obraSocialBuscador.value || "";
    this.filtroObrasSociales = this.obrasSociales.filter((obra) =>
      obra.nombre.toUpperCase().includes(texto.toUpperCase())
    );
  }

  onObraSocialChange() {
    const obraSocial = this.pacienteForm.get("obraSocial").value;
    if (obraSocial && obraSocial !== 0 && this.recetasHabilitadas) {
      this.pacienteForm
        .get("numeroAfiliado")
        .setValidators([Validators.required]);
    } else {
      this.pacienteForm.get("numeroAfiliado").clearValidators();
    }
    this.pacienteForm.get("numeroAfiliado").updateValueAndValidity();
  }

  calculoEdad(fechaNacimiento: MatDatepickerInputEvent<Date>) {
    let age = 0;
    if (fechaNacimiento.value === null) {
      return this.pacienteForm.get("edad").patchValue(age);
    }
    const today = new Date();
    const birthDate = fechaNacimiento.value;
    age = today.getFullYear() - birthDate.getFullYear();
    const month = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    this.pacienteForm.get("edad").patchValue(age);
    this.pacienteForm.get("edad").disable();
  }
}
